import api from './axios';

/**
 * Network tree + commission ledger (spec §8.2).
 *
 * Amounts come back as precision-preserving strings (Rule 79) — pass them
 * straight to formatPeso(), never through parseFloat before display.
 */
export const getMyTree           = ()             => api.get('/v1/network/my-tree');
export const getMemberTree       = (memberId)     => api.get(`/v1/network/tree/${memberId}`);
export const getCommissionSummary = (params = {}) => api.get('/v1/commissions/summary', { params });
export const listCommissions     = (params = {})  => api.get('/v1/commissions/ledger', { params });